module.exports = __webpack_public_path__ + "6b707c61/img/comments-icon.fdec7fdb.svg";